<template>
  <div :class="`c-nav-menu__category c-nav-menu__category--${toCssName(category)}`">
    <h4 class="c-nav-menu__item">{{category}}</h4>
    <ul class="c-nav-menu__category-list">
      <template v-if="posts" v-for="post in filterCategory(category)">
        <transition name="fade">
          <li :class="`c-nav-menu__category-list-item ${toCssName(category)}`" >
            <router-link class="c-nav-menu__category-list-link" :to="{ name: 'post', params: { id: post.uid }}">
              <span class="">{{getTextContent(post.data.title)}}</span>
            </router-link>
          </li>
        </transition>
      </template>
    </ul>
  </div>
</template>

<script>
import PrismicDOM from 'prismic-dom'

export default {
  name: 'nav-menu-category',
  props: {
    posts: Array,
    category: String
  },
  methods: {
    getTextContent (str) {
      return str ? PrismicDOM.RichText.asText(str) : ''
    },
    filterCategory (category) {
      return this.posts.filter(function (post) {
        return post.data.category === category
      })
    },
    toCssName (str) {
      return str.replace(/\s+/g, '-').toLowerCase()
    }
  },
  computed: {
    menuText () {
      return this.isOpen ? 'Close ✕' : 'Menu ♢'
    },
    activeClass () {
      return this.isOpen ? 'is-active' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.c-nav-menu__category {
  border-left: 1px solid #000;
  margin-bottom: 4rem;
  padding-bottom: .25rem;
  padding-left: 2rem;
  position: relative;

  &::before {
    content: "";
    background-color: red;
    box-shadow: -4px 4px 0px 1px #fff;
    top: 0;
    left: -5px;
    position: absolute;
    height: 10px;
    transform: rotate(-45deg);
    width: 10px;
  }

  &::after {
    background-color: #000;
    bottom: 0;
    content: "";
    height: 1px;
    left: -6px;
    position: absolute;
    width: 12px;
  }
}

.c-nav-menu__category--leadership::before {
  background-color: $leadership;
}

.c-nav-menu__category--leadership .c-nav-menu__category-list-link:hover {
  color: $leadership;
}

.c-nav-menu__category--legal-market::before {
  background-color: $legal-market;
}

.c-nav-menu__category--legal-market .c-nav-menu__category-list-link:hover {
  color: $legal-market;
}

.c-nav-menu__category--legal-tech::before {
  background-color: $legal-tech;
}

.c-nav-menu__category--legal-tech .c-nav-menu__category-list-link:hover {
  color: $legal-tech;
}

.c-nav-menu__category--management::before {
  background-color: $management;
}

.c-nav-menu__category--management .c-nav-menu__category-list-link:hover {
  color: $management;
}

.c-nav-menu__category-list {
  list-style-type: none;
  padding-left: 0;
  text-transform: uppercase;
}

.c-nav-menu__category-list-item {
  display: inline-block;
  margin-bottom: 1rem;
  transition: color, margin .2s ease-in-out;

  &:hover {
    margin-left: .5rem;
  }
}

.c-nav-menu__category-list-link {
  color: #000;
  font-family: $font-heading;
  font-size: .9rem;
  font-weight: 700;
}

.c-nav-menu__item {
  font-size: 1rem;
  font-style: italic;
  font-weight: 300;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// NavMenuCategory.vue?684adea0